export interface Book {
  id: string;
  badge: string;
  title: string;
  subtitle: string;
  author: string;
  description: string;
  highlights: string[];
  image: string;
  availability: string;
  url: string;
}

export const books: Book[] = [
  {
    id: 'auf-dem-weg-zu-mir',
    badge: 'Mindsettagebuch',
    title: 'Auf dem Weg zu mir!',
    subtitle: 'Das Mindsettagebuch für positive Veränderungen',
    author: 'Stephanie & Milo Wolf',
    description:
      'Kleine Schritte, große Veränderungen: Dieses Mindsettagebuch begleitet dich auf deinem persönlichen Weg – hin zu mehr Klarheit, innerer Stärke und einem Leben, das wirklich zu dir passt. Mit inspirierenden Impulsen, Reflexionsfragen und praktischen Übungen hilft es dir, neue Gewohnheiten zu entwickeln und deine Resilienz zu stärken.',
    highlights: [
      'Inspirierende Impulse für jeden Tag',
      'Reflexionsfragen & praktische Übungen',
      'Mehr Achtsamkeit und ein stärkeres Mindset',
      'Begleiter für deinen Weg zu einem erfüllten Leben',
    ],
    image:
      'https://storage.helloreaddy.io/project_files/30c86f7f-bbcb-4a08-b3cc-3e2631afcba6/e0caabe0-5b48-4018-aeb1-3b767d405e48_compressed_Mindsettagebuch-im-grnen-Naturlook.webp',
    availability: 'Erhältlich bei Amazon',
    url: 'https://link.amazon/B06vBKjA2',
  },
  {
    id: 'inklusive-foerderung',
    badge: 'Fachbuch',
    title: 'Inklusive Förderung',
    subtitle: 'Soziales-Kompetenzen & Mindset-Training zur Vorbereitung auf den Arbeitsmarkt',
    author: 'Stephanie Wolf',
    description:
      'Persönlichkeitsentwicklung durch soziale Fähigkeiten, mentale Stärke und Entspannung: Dieses Fachbuch richtet sich an Fachkräfte in Werkstätten, Förderschulen und Bildungsträgern. Es zeigt, wie sich soziale Kompetenzen und ein starkes Mindset praxisnah fördern lassen – als ideale Ergänzung zu meinen Kurskonzepten.',
    highlights: [
      'Persönlichkeitsentwicklung durch soziale Fähigkeiten',
      'Mentale Stärke & Entspannung als Basis',
      'Für Werkstätten, Förderschulen & Bildungsträger',
      'Praxiswissen aus der täglichen Arbeit',
    ],
    image:
      'https://storage.helloreaddy.io/project_files/30c86f7f-bbcb-4a08-b3cc-3e2631afcba6/1bc9162c-f618-465d-900c-b50b38fb5aba_compressed_Inklusive-Frderung--Grnes-Buch-Set-am-Schreibtisch.webp',
    availability: 'Erhältlich bei Amazon',
    url: 'https://link.amazon/B0bmVrZ1W',
  },
];